import ROUTER_PATH from 'app/routes/routerPath';
import LocalStorageService from 'app/services/localStorage';
import React, { ReactElement, useState } from 'react';
import { Navigate, Outlet } from "react-router-dom";

const GuestGuardedRoute = function GuardedRoute(): ReactElement {
    const [isLoggedIn] = useState(LocalStorageService.isLoggedIn());
    return !isLoggedIn ? <Outlet /> : <Navigate to={ROUTER_PATH.portofolio} />;
};

export default GuestGuardedRoute;
